import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';

import { connect } from 'react-redux';

import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

import EsmsModal from '../../components/EsmsModal';
import CancelButton from '../../components/CancelButton';
import ConfirmButton from '../../components/ConfirmButton';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as BasAgentActions from '../../actions/basAgentActions';

import classes from './DeleteAgentModal.module.css';

class DeleteAgentModal extends Component {
    state = {
        formIsValid:  false,
        formControls: {
            delete: {
                value:       '',
                placeholder: 'Delete Confirmation'
            }
        }
    }

    handleChange = event => {
        if (event.target.value.toLowerCase() === 'delete') {
            this.setState({
                formIsValid: true
            });
        } else {
            this.setState({
                formIsValid: false
            });
        }
    }

    handleDelete = async () => {
        const { companyId } = this.props.companyInfo;
        const { agentId, agentName, reroute } = this.props;
        const agentData = {
            name: agentName
        };

        const isDeleted = await this.props.deleteBasAgent(companyId, agentId, agentData);

        if (!reroute && isDeleted) this.handleClose();

        if (reroute && isDeleted) {
            this.props.clearErrors();

            reroute();
        }
    }

    handleClose = () => {
        this.setState({
            formIsValid:  false,
            formControls: {
                delete: {
                    value: ''
                }
            }
        });

        this.props.clearErrors();

        this.props.close();
    }

    render() {
        let { agentName, errors, open, title } = this.props;

        return (
            <EsmsModal
                errors={errors}
                open={open}
                onClose={this.handleClose}
                title={title}
            >
                <p>
                    If a BAS agent is associated with this Agent Configuration, the Serial Number will be released and will be available for assignment to a different Agent Configuration.
                </p>
                <p>
                    If you are just moving a BAS Agent to a different BAS, then you can leave this Agent Configuration and unassign the BAS Agent. This will allow you to assign a new BAS Agent at a later date to the current Agent Configuration.
                </p>
                <p>
                    Are you sure you want to delete Agent Configuration: {agentName}
                </p>
                <p>
                    To confirm, please type the word <span className={classes.warning}>DELETE</span> in the field below.
                </p>
                <FormControl className={classes.fullWidth}>
                    <InputLabel
                        htmlFor="delete"
                        classes={{
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        {this.state.formControls.delete.placeholder}
                    </InputLabel>
                    <Input
                        id="delete"
                        onKeyUp={this.handleChange}
                        name="delete"
                        classes={{
                            underline: classes.cssUnderline,
                            root:      classes.input
                        }}
                    />
                </FormControl>
                <div className={classes.buttonContainer}>
                    <CancelButton cancel={this.handleClose} />
                    <ConfirmButton
                        label="confirm"
                        type="button"
                        confirm={this.handleDelete}
                        disabled={!this.state.formIsValid}
                    />
                </div>
            </EsmsModal>
        );
    }
}

DeleteAgentModal.propTypes = {
    agentId:   string,
    agentName: string,
    close:     func.isRequired,
    open:      bool.isRequired,
    title:     string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo: state.companyInfo,
        errors:      state.messages.errors
    };
};

const mapDispatchToProps = {
    ...ApplicationMessageActions,
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAgentModal);
